import {type PropsWithChildren, useSyncExternalStore} from 'react'

import type {ExperimentScope, ExperimentStore} from './internal'
import {ExperimentScopeContext, ExperimentStoreContext} from './experiment-context'

export function ExperimentDocumentProvider({store, children}: PropsWithChildren<{store: ExperimentStore}>) {
  const scope = useSyncExternalStore(store.subscribe, store.getScope, store.getScope)

  return (
    <ExperimentStoreContext value={store}>
      <ExperimentScopeContext value={scope}>{children}</ExperimentScopeContext>
    </ExperimentStoreContext>
  )
}

export function ExperimentScopeProvider({scope, children}: PropsWithChildren<{scope: ExperimentScope}>) {
  return <ExperimentScopeContext value={scope}>{children}</ExperimentScopeContext>
}
